// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_hh","gallery__header":"c-n_hi","gallery__thumbs":"c-n_hj"};